import { SxProps, Theme } from "@mui/material";
import theme from "../../theme";

const style: SxProps<Theme> = [
  {
    height: "100%",
    width: 500,
    mt: 1,
    mb: 1,
    "& .document-container": {
      background: theme.palette.grey[200],
      borderRadius: "6px",
      padding: "14px 12px",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
      "& .document-btnadd": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        "& > p": {
          color: theme.palette.primary.main,
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: 15,
        },
        "& button": {
          fontSize: 13,
          "& svg": {
            margin: 0,
          },
        },
        "& > svg": {
          marginLeft: "8px",
        },
        "& .filename": {
          mt: 1,
        },
      },
      "& label": {
        width: "100%",
        height: "100%",
        fontSize: 13,
        color: theme.palette.grey[800],
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        "& svg": {
          marginLeft: "8px",
        },
        "& > div": {
          display: "flex",
          alignItems: "space-between",
          marginBottom: "4px",
        },
        "& .loading": {
          "& svg": {
            mr: 0,
            ml: 0,
          },
        },
        "& span": {
          cursor: "pointer",
        },
      },
    },
    "& .document-subtitle": {
      fontSize: 11,
      lineHeight: 0,
      paddingTop: 1,
      display: "flex",
      justifyContent: "flex-end",
      mt: "4px",
      color: theme.palette.grey[800],
    },
    "& .error": {
      lineHeight: 0,
      paddingTop: 1,
      display: "flex",
      justifyContent: "flex-end",
      mt: 2,
    },
  },
];

export default style;
